<div class="main-container lg-view" *ngIf="!isLoading">
	<h3>Change Note</h3>

	<div class="main-form">
		<form [formGroup]="formModel">
			<fieldset>
				<legend>{{ followUp.jobDetails.jobName }}</legend>

				<mat-form-field>
					<mat-label>Note</mat-label>
					<textarea matInput formControlName="description" rows="9"></textarea>
				</mat-form-field>

				<mat-form-field class="calendar">
					<mat-label>Calendar</mat-label>
					<input matInput [matDatepicker]="picker" formControlName="dueDate">
					<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
					<mat-datepicker #picker></mat-datepicker>
				</mat-form-field>
			</fieldset>
		</form>
	</div>
</div>

<div class="actions-container md-view" *ngIf="!isLoading">
	<action-button [icon]="ButtonIcons.Exit" [name]="'Back'" [subpage]="'..'"></action-button>
	<action-button [icon]=" ButtonIcons.Submit" [name]="'Submit'" [clickAction]="submitComment.bind(self)"
		[disabled]="formModel.invalid"></action-button>
</div>